import * as React from "react";

const MOBILE_BREAKPOINT = 768;

export function useIsMobile() {
  // Read the width on the first render, so phones never flash the desktop layout.
  const [isMobile, setIsMobile] = React.useState<boolean | undefined>(() =>
    typeof window.matchMedia === "function"
      ? window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 0.02}px)`).matches
      : undefined,
  );

  React.useEffect(() => {
    // 767.98px, not 767px, so fractional widths from browser zoom agree with Tailwind's md:
    // (min-width: 768px). Range syntax such as (width < 768px) needs Safari 16.4.
    const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 0.02}px)`);
    // Read the query's own result: WebKit can fire "change" during a device rotation
    // before window.innerWidth reports the new width.
    const onChange = (event: MediaQueryListEvent) => {
      setIsMobile(event.matches);
    };
    mql.addEventListener("change", onChange);
    setIsMobile(mql.matches);
    return () => mql.removeEventListener("change", onChange);
  }, []);

  return isMobile;
}
